import { useIntl } from 'react-intl';
import { JSX, useMemo } from 'react';

import ministryLogo from '../../../assets/images/logo-founders/logo-black.svg';
import ebrdLogo from '../../../assets/images/logo-founders/ebrd-logo.svg';
import fbaLogo from '../../../assets/images/logo-founders/fba-logo.svg';
import kornFerryLogo from '../../../assets/images/logo-founders/korn-ferry.svg';
import './logos.styles.scss';

export const Logos = (): JSX.Element => {
  const intl = useIntl();
  const founderLogos = useMemo(() => ([
    { width: 140, height: 40, icon: ministryLogo, alt: 'logo.alt' },
    { width: 76, height: 40, icon: ebrdLogo, alt: 'ebrd.logo.alt' },
    { width: 83.5, height: 40, icon: fbaLogo, alt: 'fba.logo.alt' },
    { width: 138, height: 40, icon: kornFerryLogo, alt: 'kornFerry.logo.alt' },
  ]), []);

  return (
    <ul className="wrapper">
      {founderLogos.map((logo, index) => (
        <li key={index}>
          <img
            height={logo.height} className="logo"
            width={logo.width}
            src={logo.icon}
            alt={intl.formatMessage({ id: logo.alt, defaultMessage: '' })}
          />
        </li>
      ))}
    </ul>
  );
};
